import React from 'react';
import { motion } from 'framer-motion';

const ReferencesPage = () => {
  return (
    <div className="pt-20">
      {/* Hero Section with Background Image */}
      <section className="relative py-32 bg-gradient-to-br from-[#3466ad] to-[#2a5291] text-white overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <motion.img
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.3 }}
            src="https://canv.wasacon.com/rudt-bau/_assets/media/cc754052e1bb6417d352f37a40fb4d3a.jpg"
            alt="Referenzen Hintergrund"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Dark Overlay for better text visibility */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/50"></div>

        {/* Content */}
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-4xl md:text-6xl font-bold mb-6">
              Unsere Referenzen
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-4xl mx-auto">
              Überzeugen Sie sich von der Qualität unserer Arbeit. Diese Projekte zeigen unser Können und unsere Erfahrung.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              Unsere Erfolge in Zahlen
            </h2>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.1 }}
              className="text-center"
            >
              <div style={{
      color: 'rgb(52, 102, 173)'
    }} className="text-4xl font-bold text-[#3466ad] mb-2">40+</div>
              <div className="text-gray-600 font-medium">Projekte realisiert</div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-center"
            >
              <div style={{
      color: 'rgb(52, 102, 173)'
    }} className="text-4xl font-bold text-[#3466ad] mb-2">20+</div>
              <div className="text-gray-600 font-medium">Jahre Erfahrung</div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.3 }}
              className="text-center"
            >
              <div className="text-4xl font-bold text-[#3466ad] mb-2">98%</div>
              <div className="text-gray-600 font-medium">Zufriedene Kunden</div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.4 }}
              className="text-center"
            >
              <div style={{
      color: 'rgb(52, 102, 173)'
    }} className="text-4xl font-bold text-[#3466ad] mb-2">4</div>
              <div className="text-gray-600 font-medium">Fachkräfte im Team</div>
            </motion.div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReferencesPage;